import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import subDistrict from "../../../containers/modules/master/sub-district";

export default function SubDistrictRoute( props ) {
    const {authUser}=props
    return (
        <Route
            path="sub-district"
            index
                element={
                  <AccessControl
                    name={"Sub District List"}
                    auth={authUser}
                    component={subDistrict}
                  />
                }
        />
    )
}